"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useApplyVirtualCoin = void 0;
const react_1 = require("react");
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const StatisticsApi_1 = require("../../../apis/StatisticsApi");
function appliedVirtualCoinStore() {
    /**当存在多个hooks时，用来同步is_applied这个状态 */
    const subject = new rxjs_1.Subject();
    const stateRef = {
        current: {
            isLoading: false,
            isError: false,
            isApplied: false,
        },
    };
    function next(s) {
        const newState = Object.assign({}, stateRef.current, s);
        stateRef.current = newState;
        subject.next(newState);
    }
    function checkApplied() {
        next({ isLoading: true });
        return (0, StatisticsApi_1.checkAppliedVirtualCoin)().subscribe({
            next: ({ is_applied }) => {
                next({ isApplied: is_applied, isLoading: false, isError: false });
            },
            error: () => {
                next({ isLoading: false, isError: true });
            }
        });
    }
    function applyVirtualCoin() {
        return (0, StatisticsApi_1.applyVirtualCoin)().pipe((0, operators_1.tap)(() => {
            next({ isApplied: true, isLoading: false, isError: false });
        }));
    }
    function getObserver() {
        return subject;
    }
    return {
        checkApplied,
        applyVirtualCoin,
        getObserver,
    };
}
const AppliedPUSDStore = appliedVirtualCoinStore();
/**检测是否已经申请过虚拟币，并提供申请虚拟币的接口 */
function useApplyVirtualCoin(userId = "") {
    const [isApplied, setIsApplied] = (0, react_1.useState)(false);
    const [loading, setLoading] = (0, react_1.useState)(true);
    (0, react_1.useEffect)(() => {
        const sub = AppliedPUSDStore.getObserver().subscribe({
            next: (state) => {
                setIsApplied(state.isApplied);
                setLoading(state.isLoading);
            },
            error: () => { }
        });
        return () => {
            sub.unsubscribe();
        };
    }, []);
    (0, react_1.useEffect)(() => {
        if (!userId) {
            return;
        }
        const sub = AppliedPUSDStore.checkApplied();
        return () => {
            sub.unsubscribe();
        };
    }, [userId]);
    return {
        /**是否申请过虚拟币 */
        isApplied,
        /**如果为true则说明正在请求后端数据（仅限于isApplied字段）*/
        loading,
        /**申请虚拟币 */
        applyVirtualCoin: AppliedPUSDStore.applyVirtualCoin,
    };
}
exports.useApplyVirtualCoin = useApplyVirtualCoin;
